import { Message } from 'element-ui'
import dayjs from 'dayjs'

/**
 * 弹出普通消息
 * @param {String} msg 消息内容
 */
export function info(msg) {
  Message({
    type: 'info',
    message: msg,
    duration: 2000,
  })
}
/**
 * 弹出警告消息
 * @param {String} msg 消息内容
 */
export function warning(msg) {
  Message({
    type: 'warning',
    message: msg,
    duration: 2000,
  })
}

/**
 * 弹出成功消息
 * @param {String} msg 消息内容
 */
export function success(msg) {
  Message({
    type: 'success',
    message: msg,
    duration: 2000,
  })
}

export function getQueryVariable(variable) {
  let after = window.location.hash.split('?')[1]
  if (after) {
    let reg = new RegExp('(^|&)' + variable + '=([^&]*)(&|$)')
    let r = after.match(reg)
    if (r != null) {
      return decodeURIComponent(r[2])
    } else {
      return null
    }
  }
}
// 简单到树
export function translateDataToTree(data) {
  let parents = data.filter(value => value.pid === -1)
  let children = data.filter(value => value.pid !== -1 && value.pid != null)
  let translator = (parents, children) => {
    parents.forEach(parent => {
      children.forEach((current, index) => {
        if (current.pid === parent.id) {
          let temp = JSON.parse(JSON.stringify(children))
          temp.splice(index, 1)
          translator([current], temp)
          typeof parent.children !== 'undefined' ? parent.children.push(current) : (parent.children = [current]) //NOSONAR
        }
      })
    })
  }
  translator(parents, children)
  return [
    {
      id: -1,
      pid: null,
      label: '无',
    },
  ].concat(parents)
}

// 树到简单
export function treeToList(tree) {
  let queen = []
  let out = []
  queen = queen.concat(JSON.parse(tree))
  while (queen.length) {
    let first = queen.shift()
    if (first.jobs && first.jobs.length > 0) {
      Array.prototype.forEach.call(first.jobs, item => {
        item.pid = first.id
        item.isJob = true
        item.iconSkin = 'isjob'
        out.push(item)
      })
    }
    if (first.children && first.children.length > 0) {
      queen = queen.concat(first.children)
      delete first['children']
    }
  }
  return out
}

// 树到简单-children
export function treeToListByC(tree) {
  let queen = []
  let out = []
  queen = queen.concat(JSON.parse(tree))
  while (queen.length) {
    let first = queen.shift()
    if (first.children && first.children.length > 0) {
      Array.prototype.forEach.call(first.children, item => {
        item.pid = first.id
        out.push(item)
      })
      queen = queen.concat(first.children)
      delete first['children']
    }
    out.push(first)
  }
  let allArr = unique(out)
  return allArr.sort(compare('ouOrder'))
}

// 排序
export function compare(ouOrder) {
  return (a, b) => {
    let value1 = a[ouOrder]
    let value2 = b[ouOrder]
    return value1 - value2
  }
}

// 数组去重
export function unique(arr) {
  return Array.from(new Set(arr))
}

export function _btoa(s) {
  let base64hash = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  let i = 0
  let prev
  let ascii
  let mod
  let result = []
  while (i < s.length) {
    ascii = s.charCodeAt(i)
    mod = i % 3
    switch (mod) {
      case 0:
        result.push(base64hash.charAt(ascii >> 2))
        break
      case 1:
        result.push(base64hash.charAt(((prev & 3) << 4) | (ascii >> 4)))
        break
      case 2:
        result.push(base64hash.charAt(((prev & 0x0f) << 2) | (ascii >> 6)))
        result.push(base64hash.charAt(ascii & 0x3f))
        break
    }
    prev = ascii
    i++
  }
  if (mod === 0) {
    result.push(base64hash.charAt((prev & 3) << 4))
    result.push('==')
  } else if (mod === 1) {
    result.push(base64hash.charAt((prev & 0x0f) << 2))
    result.push('=')
  }
  return result.join('')
}

export function _atob(s) {
  let base64hash = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  s = s.replace(/\s|=/g, '')
  let cur
  let prev
  let mod
  let i = 0
  let result = []
  while (i < s.length) {
    cur = base64hash.indexOf(s.charAt(i))
    mod = i % 4
    switch (mod) {
      case 0:
        break
      case 1:
        result.push(String.fromCharCode((prev << 2) | (cur >> 4)))
        break
      case 2:
        result.push(String.fromCharCode(((prev & 0x0f) << 4) | (cur >> 2)))
        break
      case 3:
        result.push(String.fromCharCode(((prev & 3) << 6) | cur))
        break
    }
    prev = cur
    i++
  }
  return result.join('')
}

export function setSession(name, value) {
  // if (name !== 'buttenpremissions') {
  //   sessionStorage.setItem(_btoa(name), _btoa(value))
  // } else {
  //   sessionStorage.setItem(_btoa(name), _btoa(value))
  // }
  // 用户名称和权限列表防止有中文内容，不做base64加密
  if (name === 'username' || name === 'buttenpremissions') {
    sessionStorage.setItem(_btoa(name), value)
  } else {
    sessionStorage.setItem(_btoa(name), _btoa(value))
  }
}

export function getSession(name) {
  let value = sessionStorage.getItem(_btoa(name))
  if (value && name !== 'username' && name !== 'buttenpremissions') {
    value = _atob(value)
  }
  if (value) {
    return value
  } else {
    return null
  }
}

export function delSession(name) {
  sessionStorage.removeItem(_btoa(name))
}

export function setCookie(name, value, day) {
  let date = new Date()
  date.setDate(date.getDate() + day)
  document.cookie = _btoa(name) + '=' + _btoa(value) + ';expires=' + date
  // document.cookie = name + '=' + value + ';expires=' + date
}

export function getCookie(name) {
  let reg
  reg = RegExp(_btoa(name) + '=([^;]+)')
  // reg = RegExp(name + '=([^;]+)')
  let arr = document.cookie.match(reg)
  if (arr) {
    return _atob(arr[1])
  } else {
    return null
  }
}

export function delCookie(name) {
  setCookie(name, '', -1)
}

export function setSessionPromise(name, value) {
  return new Promise(resolve => {
    sessionStorage.setItem(_btoa(name), _btoa(value))
    resolve()
  })
}

export function formatDate(date, fmt) {
  console.log(date)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export function _checkIfShow(val) {
  let btnRightList = JSON.parse(getSession('buttenpremissions'))
  return btnRightList.includes(val)
}

// 判断当前时间是否超过token过期时间 过期前十分钟仍在操作则刷新过期时间
export function isTokenExpire(serverTokenExpire) {
  let now = new Date()
  now.setMinutes(now.getMinutes() + 10)
  return getUTCTime(now) >= getUTCTime(new Date(serverTokenExpire))
}
// 获取UTC时间
function getUTCTime(now) {
  let year = now.getUTCFullYear()
  let month = now.getUTCMonth()
  let date = now.getUTCDate()
  let hours = now.getUTCHours()
  let minutes = now.getMinutes()
  let seconds = now.getUTCSeconds()
  let ms = now.getUTCMilliseconds()
  return Date.UTC(year, month, date, hours, minutes, seconds, ms)
}

/**
 * 获取明日 日期字符串
 * @returns {String} 日期字符串，eg: 2021/7/27
 */
export function nextDate() {
  var now = new Date()
  now.setDate(now.getDate() + 1)
  return now.toLocaleDateString()
}

/**
 * 获取当天 日期字符串
 * @returns {String} 日期字符串，eg: 2021/7/27
 */
export function nowDate() {
  var now = new Date()
  return now.toLocaleDateString()
}

/**
 * 获取当前时间字符串 时间字符串
 * @returns {String} 时间字符串，eg: 2021-07-27 12:12:12
 */
export function now() {
  return dayjs().format('YYYY-MM-DD HH:mm:ss')
}
/**
 * 获取当前时间字符串 时间字符串
 * @returns {String} 时间字符串，eg: 2021-07-27
 */
export function nowDateTime() {
  return dayjs().format('YYYY-MM-DD')
}

// 获取地址栏参数
export const getUrlParam = name => {
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [null, ''])[1].replace(
        /\+/g,
        '%20'
      )
    ) || null
  )
}
// 获取当前日期时间 2021年6月16日 00:00::00 模式
export const getNowTime = date => {
  let year = date.getFullYear() // 年
  let month = date.getMonth() + 1 // 月
  let day = date.getDate() // 日
  let nowDate = year + '年' + month + '月' + day + '日'
  let hour = date.getHours() // 时
  hour = hour < 10 ? '0' + hour : hour // 如果只有一位，则前面补零
  let minute = date.getMinutes() // 分
  minute = minute < 10 ? '0' + minute : minute // 如果只有一位，则前面补零
  let second = date.getSeconds() // 秒
  second = second < 10 ? '0' + second : second // 如果只有一位，则前面补零
  let nowTime = `${hour}:${minute}:${second}`

  let formatDate = year + '/' + month + '/' + (day + 1) + ' ' + '00:00:00'
  let formatDateB = year + '/' + month + '/' + day + ' ' + '00:00:00'
  let lastDate = year + '/' + month + '/' + day + ' ' + '23:59:59'
  return { nowDate, nowTime, formatDate, formatDateB, lastDate }
}
export function getmaxMin(date) {
  let Maximum = parseInt(Math.max(...date))
  let Minimum = parseInt(Math.min(...date))
  return { Maximum, Minimum }
}

/**
 * 在传入的数字前面进行补0操作，直到达到指定长度
 * eg:  (111,2) -> 111
 * eg:  (111,4) -> 0111
 * @param {*} num 传入的数字
 * @param {*} n 需要的字符长度
 * @returns
 */
export function PrefixInteger(num, n) {
  if (num.toString().length > n) {
    // 数字长度超过需要长度，返回源数字
    return num
  } else {
    // 补0后返回
    return (Array(n).join(0) + num).slice(-n)
  }
}

// 时间处理
Date.prototype.format = function(fmt) {
  var o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours(), //小时
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return fmt
}
// 验证正确的手机号码
export function isPoneAvailable(poneInput) {
  var myreg = /^[1][3,4,5,7,8][0-9]{9}$/
  if (!myreg.test(poneInput)) {
    return false
  } else {
    return true
  }
}
//根据某年某月计算出具体日期(一个月的所有日)
export function getDaysInMonth(year, month) {
  const daysOfMonth = []
  month = parseInt(month, 10)
  const lastDayOfMonth = new Date(year, month, 0).getDate()
  for (let i = 1; i <= lastDayOfMonth; i++) {
    if (i < 10) {
      daysOfMonth.push('0' + i + '日') //判断是部否小于10，如果小于加0，，例如“01”
    } else {
      daysOfMonth.push(i + '日')
    }
  }
  return daysOfMonth
}

// 根据选择日期推出星期一日期
export function getWeek(data) {
  var myDate = new Date(Date.parse(data))
  var beforeDay = null
  if (Number(myDate.getDay()) > 0) {
    beforeDay = Number(myDate.getDay()) - 1
  } else if (Number(myDate.getDay()) === 0) {
    beforeDay = 6
  } else {
    beforeDay = 0
  }
  return new Date(data).getTime() - 3600 * 1000 * 24 * beforeDay
}
/**
 * 获取日期+00时00分00秒
 * @param {Date} daytime --日期
 */
export function datetimeFullZero(datetime) {
  var dateValue = new Date(new Date(new Date(datetime).toLocaleDateString()).getTime())
  var months = dateValue.getMonth() + 1 < 10 ? '0' + (dateValue.getMonth() + 1) : dateValue.getMonth() + 1
  var days = dateValue.getDate() < 10 ? '0' + dateValue.getDate() : dateValue.getDate()
  var hours = dateValue.getHours() < 10 ? '0' + dateValue.getHours() : dateValue.getHours()
  var minutes = dateValue.getMinutes() < 10 ? '0' + dateValue.getMinutes() : dateValue.getMinutes()
  var second = dateValue.getSeconds() < 10 ? '0' + dateValue.getSeconds() : dateValue.getSeconds()
  return dateValue.getFullYear() + '-' + months + '-' + days + ' ' + hours + ':' + minutes + ':' + second
}

/**
 * 获取日期+23时59分59秒
 * @param {Date} daytime --日期
 */
export function datetimeFull(datetime) {
  var dateValue = new Date(new Date(new Date(datetime).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
  var monthsEnd = dateValue.getMonth() + 1 < 10 ? '0' + (dateValue.getMonth() + 1) : dateValue.getMonth() + 1
  var daysEnd = dateValue.getDate() < 10 ? '0' + dateValue.getDate() : dateValue.getDate()
  return (
    dateValue.getFullYear() +
    '-' +
    monthsEnd +
    '-' +
    daysEnd +
    ' ' +
    dateValue.getHours() +
    ':' +
    dateValue.getMinutes() +
    ':' +
    dateValue.getSeconds()
  )
}

/**
 * 获取时分秒
 * @param {Date} sec --秒数
 */
export function timeCycleFilter(sec) {
  let hour = Math.floor(sec / 3600)
  let minute = Math.floor((sec - hour * 3600) / 60)
  let second = Math.floor(sec - hour * 3600 - minute * 60)
  if (hour < 10) {
    hour = '0' + hour
  }

  if (minute < 10) {
    minute = '0' + minute
  }

  if (second < 10) {
    second = '0' + second
  }

  if (hour === 0) {
    return minute + ':' + second
  } else {
    return hour + ':' + minute + ':' + second
  }
}
/**
 * 计算两个时间相差多少秒
 * @param {start，end} sec --两个时间
 */
export function timeFilter(start, end) {
  var date1 = new Date(start)

  var date2 = new Date(end)

  var s1 = date1.getTime(),
    s2 = date2.getTime()

  return (s2 - s1) / 1000
}
